//
//
//
//
//
//

export default {
  name: "App",
  watch: {
    $route() {
      document.title = this.$route.meta.title;
    }
  },
  created() {
    document.title = this.$route.meta.title;
  }
};



// WEBPACK FOOTER //
// ./src/App.vue